(ns app.front.view.meeting.meeting-section
  (:require [app.front.util :as futil]
            [app.front.view.meeting.meeting-core :as meeting-core]
            [app.front.view.meeting.meeting-events :as meeting-events]
            [app.front.view.meeting.meeting-subs :as meeting-subs]
            [app.front.view.workspace.section :as ws-section]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.util.util :as util]))


(defn- add-header-fields
  "Adds time information to the meeting in the form used by the UI"
  [{:meeting/keys [start end] :as meeting}]
  (merge meeting
         {:starts-at (date-util/hour-minute-in-tz start date-util/browser-timezone)
          :ends-at   (date-util/hour-minute-in-tz end date-util/browser-timezone)}))


(defn- permitted? [parent-id signal]
  (<sub [:app.front.process/signal-permitted? parent-id signal]))


(defn- create-meeting-button [tr {parent-id :db/id}]
  (when (permitted? parent-id [:process.signal/create-meeting-draft])
    (cc/button
      {:kind             :ghost
       :icon             i/plus
       :icon-description (tr [:meeting/create])
       :on-click         #(>evt [::meeting-events/create-draft parent-id])
       :size             :small}
      (tr [:meeting/create]))))


(defn meeting-list
  "Lists the meetings under the given parent sorted by starting time"
  [{:keys [tr parent]}]
  (futil/for-frag [meeting (->> (<sub [::meeting-subs/meetings (:db/id parent)])
                                (filter #(-> % :domain/state (not= :meeting.state/cancelled)))
                                (map add-header-fields)
                                (sort-by :meeting/start))]
    [meeting-core/meeting-view (util/mmap tr parent meeting)]))


(defn meetings
  "The meetings section on the workspace"
  [{:keys [tr error?] {parent-id :db/id :as parent} :parent :as opts}]
  (when (or (permitted? parent-id [:process.signal/create-meeting-draft])
            (not-empty (<sub [::meeting-subs/meetings parent-id])))
    [ws-section/section
     parent
     :pre-consultation-meetings
     (util/mmap {:heading-button [create-meeting-button tr parent]}
                tr error?)
     :meeting/meetings
     true
     [meeting-list opts]]))
